import React from 'react';
import styled from 'styled-components';
import { ToggleButtonGroup as ToggleButtonGroupBase } from '@mui/material';
import { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup/ToggleButtonGroup';
import { componentToken } from '../../style/utils';

const StyledToggleButtonGroup = styled(ToggleButtonGroupBase)<
  ToggleButtonGroupProps & { $valueSelected?: boolean }
>`
  gap: ${componentToken('segmentedButton.toggleButtonGroup.gap')};

  .MuiToggleButtonGroup-grouped {
    margin: 0 !important;
    border: 1.5px solid
      ${componentToken('segmentedButton.toggleButtonGroup.groupedBorder')} !important;
    border-radius: ${componentToken(
      'segmentedButton.toggleButtonGroup.groupedBorderRadius',
    )} !important;

    background-blend-mode: ${({ $valueSelected }) =>
      $valueSelected ? 'luminosity' : 'normal'};
    filter: grayscale(
      ${({ $valueSelected }) => ($valueSelected ? '100%' : '0')}
    );
  }

  ${({ theme }) => {
    const { selectedBorder } =
      theme.tokens.components.segmentedButton.toggleButtonGroup;
    return (
      selectedBorder &&
      `
      .MuiToggleButtonGroup-grouped.Mui-selected {
        border-color: ${selectedBorder} !important;
        filter: none;
        background-blend-mode: normal;
      }
    `
    );
  }}
`;

const SegmentedButtonGroup = React.forwardRef(
  (props: ToggleButtonGroupProps, ref: any) => (
    <StyledToggleButtonGroup
      ref={ref}
      $valueSelected={props.value != null}
      {...props}
    />
  ),
);

export default SegmentedButtonGroup;
